import React, { useContext, useRef, useState } from 'react';
import { Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Auth from "../../../Utilities/Auth";
import * as XLSX from "xlsx";
import { importAgentAction } from "../../../Redux/Action/AgentAction";
import { useDispatch } from "react-redux";
import ButtonLoader from "../../CommonComponent/ButtonLoader/ButtonLoader";
import { MemberContext } from "../AllMemberComponent";
import { importMemberAction } from "../../../Redux/Action/MemberAction";
import CommonToast from '../../../Utilities/CommonToast';

function ImportMemberForm(props) {
    // hooks
    const dispatch = useDispatch()
    const submitRef = useRef()
    // hook form props
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    // states
    const [excelFile, setExcelFile] = useState(null);
    const [excelFileError, setExcelFileError] = useState(null);
    // getting data form context
    const { setImportMemberModal, setAllMemberReload } = useContext(MemberContext)

    // handle File
    const fileType = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    const handleFile = (e) => {
        let selectedFile = e.target.files[0];
        if (selectedFile) {
            // console.log(selectedFile.type);
            if (selectedFile && fileType.includes(selectedFile.type)) {
                let reader = new FileReader();
                reader.readAsArrayBuffer(selectedFile);
                reader.onload = (e) => {
                    setExcelFileError(null);
                    setExcelFile(e.target.result);
                }
            } else {
                setExcelFileError('Please select only excel file types');
                setExcelFile(null);
            }
        } else {
            console.log('plz select your file');
        }
    }

    // on submit
    const onSubmit = (hookFormData) => {
        let userDetail = JSON.parse(Auth.header().userdetail || "{}");

        if (excelFile !== null) {
            const workbook = XLSX.read(excelFile, { type: "buffer" });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const new_member_arr = XLSX.utils.sheet_to_json(worksheet);

            let has_error = false;
            const formatted_donors = [];

            new_member_arr.forEach((data, index) => {
                const fullName = data["Name"]?.trim() || "";
                const agent_id = +data["Collector ID"] || 0
                const mobile = +data["Mobile"] || ""

                // validation only on full name
                if ((!fullName || fullName.length < 2) && !has_error) {
                    CommonToast.warning(
                        `Member name must be more than 2 characters at row ${index + 2}`
                    );
                    has_error = true;
                    return; // skip this row
                }

                else if ((!mobile || mobile.length < 10) && !has_error) {
                    CommonToast.warning(
                        `Mobile must be at least 10 digit at row ${index + 2}`
                    );
                    has_error = true;
                    return; // skip this row
                }

                else if ((!agent_id || agent_id.length < 1) && !has_error) {
                    CommonToast.warning(
                        `Collector Id must be at least 1 digit at row ${index + 2}`
                    );
                    has_error = true;
                    return; // skip this row
                }

                else if (!has_error) {
                    // formatted new data
                    const formatted_new_data = {
                        member_name: fullName || "",
                        // guardian: data["Guardian"] || "",
                        grade: data["Grade"] || "",
                        mobile: data["Mobile"] || "",
                        whats_app: data["Whatsapp"] || "",
                        state: data["State"] || "",
                        district: data["District"] || "",
                        police_station: data["Police station"] || "",
                        // area_type: data["Area type"] || "",
                        // post_office: data["Post office"] || "",
                        village: data["Village"] || "",
                        place: data["Place"] || "",
                        // pincode: data["Pincode"] || "",
                        neighborhood: data["Neighborhood"] || "",
                        city: data["City"] || "",
                        agent_id: agent_id
                    }
                    if (data.ID) formatted_new_data.id = data.ID

                    // map excel columns to backend keys
                    formatted_donors.push(formatted_new_data);
                }
            });

            if (has_error) return; // stop if any invalid row found

            const payload = {
                data: {
                    // agent_id: hookFormData.agent_id,
                    new_member_arr: formatted_donors,
                },
                setImportMemberModal,
                setAllMemberReload,
                submitRef,
            };

            !has_error && dispatch(importMemberAction(payload))
            // console.log(formatted_donors)
        } else {
            CommonToast.warning("Please upload an Excel file before submitting.");
        }
    };

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                {/*Agent id*/}
                {/* <Form.Group className="mb-2" controlId="formBasicEmail">
                    <Form.Label>Agent id</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter agent id"
                        {...register("agent_id", { required: true })}
                    /> */}
                {/*validation message*/}
                {/* {errors.agent_id && <span className="text-danger">This field is required.</span>}
                </Form.Group> */}
                <Form.Group className="mb-2" controlId="formBasicEmail">
                    <Form.Label>Upload members</Form.Label>
                    <Form.Control
                        type="file"
                        // onChange={e => handleFile(e)}
                        {...register("importedMemberExcel", {
                            required: true,
                            onChange: e => {
                                handleFile(e)
                            }
                        })}
                    />
                    {errors.importedMemberExcel && <span className="text-danger">This field is required.</span>}
                    {excelFileError && <div className='text-danger'
                        style={{ marginTop: 5 + 'px' }}>{excelFileError}</div>}
                </Form.Group>

                <Button ref={submitRef} variant="success" disabled={false} className="mt-2 btn-sm" type="submit">
                    Add
                    <ButtonLoader />
                </Button>
            </Form>
        </>
    );
}

export default ImportMemberForm;